import React, { useContext } from "react";
import appConst from "../Utilities/appConst.json";
import { LanguageContext } from "../context/language/LanguageContext";
import { useSelector } from "react-redux";

export default function AddButton(props) {
  const languageContext = useContext(LanguageContext);
  const direction = useSelector((state) => state.mode.direction);
  const platform = sessionStorage.getItem(appConst.PLATFORM);
  const source_device = sessionStorage.getItem(appConst.SOURCE_DEVICE);
  const product = sessionStorage.getItem(appConst.PRODUCT); //appConst.ORDERS_UNION
  const isLtr = direction === "ltr";

  const redirectToSite = () => {
    if (platform === appConst.PLATFORM_VAR_3) {
      backToFeed();
    } else if (source_device === "web" && product === "tiles") {
      window.location.replace(appConst.LUPA_TILES_SITE);
    } else if (source_device === "mobile" && product === "tiles") {
      window.location.replace(appConst.LUPA_TILES_TINY_SITE);
    } else if (product === "calendars") {
      window.location.replace(appConst.LUPA_CALENDAR_SITE);
    } else if (product === "books") {
      backToFeed();
    }
  };

  const backToFeed = () => {
    const parentUrl = sessionStorage.getItem('PARENT_URL');
    const isEmbedded = window.self !== window.top;

    if (typeof window.LupaNative !== "undefined") {
      window.LupaNative.exit();
    } else if (isEmbedded && parentUrl) {
      const parentOrigin = new URL(parentUrl).origin;
      const redirectUrl = `${parentOrigin}/my-albums`;
      window.parent.postMessage({
        type: 'NAVIGATE',
        url: redirectUrl
      }, parentOrigin);
    } else {
      // Opened top-level (calendar): no parent to postMessage, so navigate ourselves.
      backToReferrer();
    }
  };

  const backToReferrer = () => {
    if (!document.referrer) return;
    try {
      const origin = new URL(document.referrer).origin;
      // Guard against our own origin — that would just reload the basket.
      if (origin !== window.location.origin) {
        window.location.replace(origin);
      }
    } catch (e) {
      console.error('Failed to resolve referrer:', e);
    }
  };

  return (
    <>
      <div
        className="fixed end-[16px] z-[41] md:hidden"
        data-testid="basket-add-button"
        style={{
          bottom: `calc(125px + 16px + ${
            props.footerContentHeight ? props.footerContentHeight + 21 : 0
          }px)`,
        }}
      >
        <button
          type="button"
          className="inline-flex h-10 w-10 appearance-none items-center justify-center rounded-full border-0 bg-lupa-brand text-ink shadow-none outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
          onClick={redirectToSite}
          aria-label="add"
        >
          <span className="text-2xl leading-none" aria-hidden>
            +
          </span>
        </button>
      </div>

      <div
        className={`fixed bottom-[53px] z-[2] hidden md:block ${
          isLtr ? "left-[50px] right-auto" : "right-[50px] left-auto"
        }`}
        data-testid="basket-add-button"
      >
        <button
          type="button"
          className="inline-flex h-fit appearance-none items-center rounded-full border-2 border-solid border-lupa-brand bg-white text-xl text-secondary-foreground shadow-none outline-none ring-0 hover:bg-lupa-highlight focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 flex-row-reverse"
          onClick={redirectToSite}
        >
          <div className="py-2 ps-3 pe-3 font-ploni">
            {languageContext.getTranslation(appConst.ADD_LUPA_TO_BASKET)}
          </div>
          <span className="ps-2 pe-3 text-3xl leading-none text-lupa-brand" aria-hidden>
            +
          </span>
        </button>
      </div>
    </>
  );
}
